// @ts-strict
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as urltemplate from 'url-template';

/**
 * Initialize the web app service BEFORE the root application component is
 * loaded.  Simply add the module to the root module, and the initializer
 * will be automatically added.
 */
@Injectable({
  providedIn: 'root'
})
export class LMWebAppInitializerService {
  private accessibleWebApps: LMWebAppSpec[] = [];
  private _error: any;

  /**
   * Constructor.
   */
  constructor(private http: HttpClient) {}

  getAccessibleWebApps(): LMWebAppSpec[] {
    return this.accessibleWebApps;
  }

  public hasError(): boolean {
    return this._error !== undefined;
  }

  public getError(): any | undefined {
    return this._error;
  }

  /**
   * Initializes the locale for this web application.
   */
  async initialize(): Promise<boolean> {
    // return Promise.resolve(true);

    const url = this.getAccessibleWebAppsUrl();
    const userTimeZone = this.getHeaderForUserTimeZone();

    return new Promise((resolve, reject) => {
      this.http.get(url, userTimeZone).subscribe({
        next:  (response: any) => {
          this.accessibleWebApps = response;
          resolve(true);
        },
        error: (error) => {
          this._error = error;
          resolve(true);
        }
      });
    });
  }

  private getAccessibleWebAppsUrl(): string {
    const urlCompiledTemplate = urltemplate.parse(accessibleWebAppsUrl);
    const url = urlCompiledTemplate.expand({
      urlPdlOrDa: LandmarkContext.urlPdlOrDa,
      webApp: LandmarkContext.webApp
    });
    return url;
  }

  private getHeaderForUserTimeZone(): any {
    try {
      const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      if (userTimeZone) {
        return { headers: { 'user.timezone.id': userTimeZone } };
      }

      const rightNow = new Date();
      const stdTime = new Date(rightNow.getFullYear(), 0, 1, 0, 0, 0, 0);
      const dstTime = new Date(rightNow.getFullYear(), 6, 1, 0, 0, 0, 0);

      const offset: string = (-(stdTime.getTimezoneOffset() / 60)).toString();
      const dstOffset: string = (-(dstTime.getTimezoneOffset() / 60)).toString();
      return { headers:
          { 'user.timezone.offset': offset,
            'user.timezone.dst':    dstOffset } };
    } catch (e: any) {
      // fail safe
      return {};
    }
  }

}

export function LMWebAppInitializerFactory(service: LMWebAppInitializerService) {
  return () => service.initialize();
}
